import { inject, Injectable } from '@angular/core';
import { Observable, map, switchMap, of } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from 'environments/environment';
import { IToken } from "../classes/token.interfaces";
import { IIziPayRequestConfig } from "../classes/payment.interfaces";

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly http = inject(HttpClient);

  getTokenSession(transactionId: string, ws_token: string): Observable<IIziPayRequestConfig> {
    return of(true)
      .pipe(
        switchMap(() => {
          return this.getTokenToConsumApi();
        }),
        switchMap((token: IToken) => {
          return this.getAviData(transactionId, token.access_token, ws_token)
            .pipe(
              map((obj: IIziPayRequestConfig) => {
                obj.access_token = token.access_token;
                return obj;
              })
            )
        })
      );
  }

  getTokenToConsumApi(): Observable<IToken> {
    const url = environment.bff_token_session_url;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Ocp-Apim-Subscription-Key': `${ environment.bff_token_session_key }`,
      'Authorization': `Basic ${ environment.bff_token_session_auth }`
    });

    // Configura los datos de la solicitud
    const body = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('scope', 'token:application');

    return this.http.post<IToken>(url, body, { headers });
  }

  getAviData(transactionId: string, auth_token: string, ws_token: string): Observable<IIziPayRequestConfig> {
    const url = environment.bff_token_avi_url;

    const params = new HttpParams().set('token', ws_token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Api-Force-Sync': 'true',
      'X-Correlation-Id': transactionId,
      'X-Transaction-Id': transactionId,
      'X-Api-Version': environment.bff_transger_avi_api_ver,
      'Ocp-Apim-Subscription-Key': environment.bff_transger_avi_sub_key,
      'Authorization': 'Bearer ' + auth_token,
    });

    return this.http.get<IIziPayRequestConfig>(url, { headers, params });
  }

}



